<template>
  <div v-if="receivedQuestionnaires.length > 0">
    <v-row v-if="chooseMultiple" style="width: 100%" class="flex-grow-0">
      <v-col>
        <QuestionnaireMessageCard
          icon="icon-lightbulb-outline"
          :disable-button="isForwardingDisabled()"
          @click="routeToUploadSuppliers"
        >
          <template #title>
            Can’t fill out the questionnaires right now?
          </template>
          To prevent delaying the supply chain mapping process, you can forward
          the selected questionnaires to suppliers before filling them out
          yourself. You can go back and answer the questionnaires later.
          <template #buttonText> Forward to suppliers</template>
        </QuestionnaireMessageCard>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="text-left pb-4">
          <p>Choose which company you would like to share information with.</p>
          <p>You can edit your response at a later step.</p>
        </div>
        <ReceivedQuestionnairesTable
          :received-questionnaires="receivedQuestionnaires"
          :choose-multiple="chooseMultiple"
          @view-questionnaire-status="viewQuestionnaireStatus"
          @selected-questionnaires-updated="setSelectedQuestionnaires"
        />
      </v-col>
    </v-row>
  </div>
  <div v-else>
    <p>No questionnaires to show.</p>
  </div>
</template>

<script setup lang="ts">
import ReceivedQuestionnairesTable from "@/views/questionnaires/ReceivedQuestionnairesTable.vue";
import { useRouter } from "vue-router";
import { RouterPath } from "@/models/enum/routerPath";
import { useSelectedQuestionnaire } from "@/stores/selectedQuestionnare";
import { useSenderStore } from "@/stores/sender";
import type ReceivedQuestionnaire from "@/models/receivedQuestionnaire";
import QuestionnaireMessageCard from "@/components/questionnaire/QuestionnaireMessageCard.vue";
import { onMounted } from "vue";

defineProps<{
  receivedQuestionnaires: ReceivedQuestionnaire[];
  chooseMultiple: boolean;
}>();

const router = useRouter();
const selectedQuestionnaireStore = useSelectedQuestionnaire();
const senderStore = useSenderStore();

onMounted(() => {
  setSelectedQuestionnaires([]);
});

const viewQuestionnaireStatus = (questionnaire: ReceivedQuestionnaire) =>
  setAndRoute(RouterPath.ReceivedQuestionnaireStatus, questionnaire);

function setSelectedQuestionnaires(questionnaires: ReceivedQuestionnaire[]) {
  selectedQuestionnaireStore.setSelectedQuestionnairesParams(questionnaires);
  senderStore.setSupplierParams(questionnaires[0]);
}

function routeToUploadSuppliers() {
  router.push(RouterPath.UploadSuppliersForQuestionnaire);
}

function setAndRoute(
  route: RouterPath,
  questionnaire: ReceivedQuestionnaire
): void {
  selectedQuestionnaireStore.setSelectedQuestionnaireParams(questionnaire);
  senderStore.setSupplierParams(questionnaire);
  router.push(route);
}

function isForwardingDisabled(): boolean {
  return (
    selectedQuestionnaireStore.questionnaires.length < 1 ||
    selectedQuestionnaireStore.questionnaires.every((x) => x.isBusinessPartner)
  );
}
</script>
